/**
 * 查看培训记录
 * @author xyguo
 * @date 2021-3-16
 */
 import React from 'react';
 import { connect } from 'dva';
 import { framework_tool, component_tool, utils_tool } from '@/tool';
 let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol,WizSpin,WizButton } = component_tool;
 let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
 let { $$, checkStrLength } = utils_tool;
 import '../../../../styles/containers/train/path/requirement/style.less'
 class UpdateBenchmarkState extends WizContainer {
 
   componentName = 'UpdateBenchmarkState';
 
   constructor(props) {
    super(props)
    let { record } = props
    this.state = {
        record,
        benchmarkState : record.benchmarkState,
        timestamp: new Date().getTime()
    }
}
 
   _componentDidMount() {
     
   }

   _recordColumns = (record = {}) => {
    return [
        {
            title: '实践人员',
            name: 'name',
            formItem: {
                type: 'custom',
                render: () => {
                    return <div>{record.positionName}-{record.fullName}</div>
                }
            }
        },
        {
            title: '实践结果',
            name: 'benchmarkState',
            dict: [
                { code: 0, codeName: '合格' },
                { code: 1, codeName: '不合格' }
            ],
            formItem: {
                type: 'radio',
                rules: [
                  {
                    required: true,
                    message: '请选择实践结果'
                  },
                ],
                onChange: (form, value, e) => this.setState({ benchmarkState: value })
            }
        },
        
    ]
}
 
   propsAndStateOnChange = {
    saveOrUpdateState: this._saveOrUpdateState.bind(this),
   };
 
   _saveOrUpdateState(nextProps, nextState) {
     if (nextProps.saveOrUpdateState.code === 1) {
       wizNotice.success('保存成功');
       nextProps.changeModal(false, true);
     } else {
       wizNotice.error(nextProps.saveOrUpdateState.msg);
     }
   }

   _onSave = () => {
    let {record,benchmarkState } = this.state
    if(benchmarkState!=1 && benchmarkState!=0){
      wizNotice.warn('实践结果不可为空');
      return;
    }
    const {orgId,positionId,personId} = record // benchmarkState benchmarkState
    this.doAction({
      path: 'requirementPersonnelDetail/saveOrUpdateState',
      payload: {
          key: 'saveOrUpdateState',
          apiParams: {
            orgId,positionId,personId,benchmarkState
          }
      }
  })
}

_renderFooter = () => {
  return (
      <React.Fragment>
          <WizRow className="form-btns row-item">
              <WizCol span={24}>
                  <WizButton title='保存' type='primary' onClick={() => this._onSave()}>确认</WizButton>
                  <WizButton title='重置' type='reset' onClick={() =>this.props.changeModal(false)}>取消</WizButton>
              </WizCol>
          </WizRow>
      </React.Fragment>
  )
}
 
 
   render() {
     const {requirementRecordLoading } = this.props;
     let {record, timestamp } = this.state
     let columns = this._recordColumns(record)
    // let onSubmit = this._onSave.bind(this);
     let formProps = {
      ref: 'formRef',
      key: timestamp,
      columns,
      record: record || { status: 0 },
     // preview: false,
      footer: this._renderFooter(),
      formItemLayout: {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 }
      }
  }
     return <WizForm {...formProps} />
   }
 }
 
 const mapStateToProps = (state, ownProps) => {
   const { requirementPersonnelDetail } = state;
   const saveOrUpdateState = modelUtils.getModelEntity(requirementPersonnelDetail, 'saveOrUpdateState');
   const load = modelUtils.getLoadingState(state, "requirementPersonnelDetail");
   return {
    saveOrUpdateState,
     ...load,
   };
 };
 
 export default connect(mapStateToProps)(UpdateBenchmarkState);
 
 